import React, { useRef, useEffect } from 'react';
import '../styles/DrumKit.css';

// Import sounds statically
import tom1 from '../assets/sounds/drum/tom-1.mp3';
import tom2 from '../assets/sounds/drum/tom-2.mp3';
import tom3 from '../assets/sounds/drum/tom-3.mp3';
import tom4 from '../assets/sounds/drum/tom-4.mp3';
import snare from '../assets/sounds/drum/snare.mp3';
import crash from '../assets/sounds/drum/crash.mp3';
import kick from '../assets/sounds/drum/kick-bass.mp3';

const DrumKit: React.FC = () => {
  // Refs to preload sounds and reuse them
  const audioRefs = useRef<Record<string, HTMLAudioElement>>({});

  useEffect(() => {
    // Preload sounds once
    audioRefs.current = {
      w: new Audio(tom1),
      a: new Audio(tom2),
      s: new Audio(tom3),
      d: new Audio(tom4),
      j: new Audio(snare),
      k: new Audio(crash),
      l: new Audio(kick),
    };

    // Uncomment to enable keyboard event
    // const handleKeyDown = (e: KeyboardEvent) => {
    //   const key = e.key.toLowerCase();
    //   if (audioRefs.current[key]) {
    //     playSound(key);
    //     animateButton(key);
    //   } else {
    //     console.log(`The key "${key}" is not allowed`);
    //   }
    // };

    // document.addEventListener('keydown', handleKeyDown);
    // return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const playSound = (key: string) => {
    const audio = audioRefs.current[key];
    if (audio) {
      // Clone to allow overlapping sounds
      const clonedAudio = audio.cloneNode(true) as HTMLAudioElement;
      clonedAudio.play();
    }
  };

  const animateButton = (key: string) => {
    const button = document.querySelector(`.${key}`) as HTMLElement;
    if (button) {
      button.classList.add('pressed');
      setTimeout(() => button.classList.remove('pressed'), 200);
    }
  };

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const key = e.currentTarget.textContent?.toLowerCase();
    if (key) {
      playSound(key);
      animateButton(key);
    }
  };

  return (
    <div className="panelMd grey">
      <div className="bg-drum">
        <div className="title">
          <h1>Drum 🥁 Kit</h1>
        </div>
        <div className="btn-set">
          {['w', 'a', 's', 'd', 'j', 'k', 'l'].map((char) => (
            <button key={char} className={`${char} drum`}
            onClick={handleClick}
            tabIndex={-1}>
              {char}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DrumKit;
